import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) {
    this.title.setTitle("Our People - SingX");
    this.canonicalService.updateCanonicalUrl('/team');
    this.meta.updateTag({ name: 'description', content: 'SingX has a team of professionals with decades of global experience in banking & finance. We operate with the highest level of integrity.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' })
    // this.meta.addTags([
    //   { name: 'description', content: 'SingX has a team of professionals with decades of global experience in banking & finance. We operate with the highest level of integrity.' },
    //   { name: 'author', content: 'SingX' },
    //   { name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
    // ]);
  }

  ngOnInit(): void {
  }

}
